<template>
  <div class="text-sm">
    <p class="mt-6"><b>2026.02.08</b> - Stability, performance & polish</p>
    <ul class="ml-5 pb-4 list-outside list-disc text-purple-500">
      <li>Seamless caverns room transitions; AI targeting fixes for missiles & melee.</li>
      <li>Hero XP boosts fixed when activating from a full bag.</li>
      <li>Battle rendering & memory optimizations for smoother play.</li>
      <li>Visual fixes: Devil Mask, Inspired buff, borders; peanuts animation tuned.</li>
      <li>Leaderboard crash fix.</li>
    </ul>
  </div>
</template>
